// extracted by mini-css-extract-plugin
export default {"howToClaim":"_2ZCH49dNiWh_2HyeyUZoIl","buttonContainer":"_19jImIK8YzncUvRXi9-erh","travelBlock":"_1g0EtXQAvRQk505PdJNbQP"};